import * as S from './styles.ts';
import { useState } from 'react';
import { Button, Popup } from '@template/components';
import Dropdown from '@template/components/Select/Dropdown';
import { ChevronDown, Tag } from '@template/icons';
import { useTypedSelector } from '@/redux/helpers/hooks.ts';
import useStoreTheme from '@template/providers/StoreThemeProvider.tsx';

type DomainRegistrationTermProps = {
  selected: number;
  options: Record<number, number>;
  promo?: boolean;
  onSelect: (value: number) => void;
  loading?: boolean;
};

export const DomainRegistrationTerm = ({
  selected,
  options,
  promo,
  onSelect,
  loading,
}: DomainRegistrationTermProps) => {
  const theme = useStoreTheme();
  const currency = useTypedSelector(
    (state) => state.store.site_version.currency
  );

  const [isOpen, setIsOpen] = useState(false);

  const currencySymbol = currency === 'USD' ? '$' : '£';

  const customOptions = Object.entries(options).map(([key, value]) => ({
    label: `${key} Year${Number(key) > 1 ? 's' : ''} - ${currencySymbol}${value / 100}`,
    key: key,
  }));

  return (
    <S.Wrapper>
      <Popup
        unstyled
        isOpen={isOpen}
        onOpenChange={(val) => {
          if (loading) return;
          setIsOpen(val);
        }}
        placement={'bottom-end'}
        popupContent={
          <Dropdown
            options={customOptions}
            selected={selected}
            onChange={onSelect}
            setIsOpen={setIsOpen}
          />
        }
      >
        <Button variant='light' color='default' disabled={loading}>
          {promo && (
            <Tag
              width={16}
              height={16}
              style={{
                color: theme.colors.primary.default,
              }}
            />
          )}
          {selected} Year{selected > 1 ? 's' : ''} -{' '}
          {promo ? (
            <span>
              {currencySymbol}
              {options[selected] / 100} (Promo)
            </span>
          ) : (
            <>
              {currencySymbol}
              {options[selected] / 100}
            </>
          )}
          <ChevronDown
            width={16}
            height={16}
            style={{
              transform: `rotate(${isOpen ? '180deg' : '0deg'})`,
              transition: 'transform 0.3s ease',
            }}
          />
        </Button>
      </Popup>
    </S.Wrapper>
  );
};

export default DomainRegistrationTerm;
